import { Link } from "react-router-dom";
import { TbReportSearch } from "react-icons/tb";
import { PiFlagBannerBold } from "react-icons/pi";
import { RiCustomerServiceLine } from "react-icons/ri";
import { TbAlertSquareRounded } from "react-icons/tb";

import iconToggle from "../../assets/images/menu.png";
import { SlGraph } from "react-icons/sl";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";

interface Props {
  visible: boolean;
  toggleClass?: string;
  onToggleHandler?(className: boolean): void;
}

const VerticalMenu = (props: Props) => {
  const location = useLocation();
  const isActive = (path: any) => location.pathname === path;
  let role = localStorage.getItem("role");
  console.log(role);
  const navigate = useNavigate();

  useEffect(() => {
    if (role === "LEAFG") {
      navigate("/access-denied", { replace: true });
    }
  }, [role, navigate]);
  return (
    <>
      <div
        id="vertical_menu"
        className="verticle-menu px-2"
        style={{ maxHeight: "100vh", overflowY: "auto" }}
      >
        <div className="px-2 pt-1 mb-2 position-relative">
          <a
            href="javascript:void(0)"
            onClick={() => {
              if (props.onToggleHandler != undefined) {
                props?.onToggleHandler(!props.visible);
              }
            }}
            className="menu-toogle-btn"
          >
            <img src={iconToggle} width={24} alt="" />
          </a>
        </div>

        <div className="menu-list">
          {/* <Link title="Dashboard" id="t-1" to={'/dashbaord'} className="menu-item"> <img src={iconReview} alt="icon" className="menu-icon" /></Link>
                    <Link title="Graph Analytics" id="t-graph" to={'/graph-analytics'} className="menu-item"> <img src={graphIcon} alt="Graph Analytics" className="menu-icon" /></Link>
                    <Link title="Dashboard" id="t-2" to={'/dashbaord'} className="menu-item"> <img src={icon2} alt="icon" className="menu-icon" /></Link>
                    <Link title="Dashboard" id="t-3" to={'/dashbaord'} className="menu-item"> <img src={icon3} alt="icon" className="menu-icon" /></Link>
                    <Link title="Dashboard" id="t-4" to={'/dashbaord'} className="menu-item"> <img src={icon4} alt="icon" className="menu-icon" /></Link>
                    <Link title="Settings" id="t-5" to={'/dashbaord'} className="menu-item"> <img src={icon5} alt="icon" className="menu-icon" /></Link> */}
          <Link
            id="t-1"
            to={"/graph-analytics/:company_id"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/graph-analytics/:company_id")
                ? "olivedrab"
                : "transparent",
            }}
          >
            {" "}
            <SlGraph size="22" />{" "}
            <span className="nav-text">Analytics</span>
          </Link>
          <Link
            id="t-1"
            to={"/stations"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/stations")
                ? "olivedrab"
                : "transparent",
            }}
          >
            {" "}
            <HiOutlineBuildingOffice2 size="22" />{" "}
            <span className="nav-text">Stations</span>
          </Link>
          <Link
            id="t-1"
            to={"/reports"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/reports")
                ? "olivedrab"
                : "transparent",
            }}
          >
            {" "}
            <TbReportSearch size="22" />{" "}
            <span className="nav-text">Reports</span>
          </Link>
          <Link
            id="t-1"
            to={"/manage-banner"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/manage-banner")
                ? "olivedrab"
                : "transparent",
            }}
          >
            {" "}
            <PiFlagBannerBold size="22" />{" "}
            <span className="nav-text">Banners</span>
          </Link>
          <Link
            id="t-1"
            to={"/service-request-complaint"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/service-request-complaint")
                ? "olivedrab"
                : "transparent",
            }}
          >
            {" "}
            <RiCustomerServiceLine size="22" />{" "}
            <span className="nav-text">Service Management</span>
          </Link>
          <Link
            id="t-1"
            to={"/alerts"}
            className="menu-item"
            style={{
              backgroundColor: isActive("/alerts")
                ? "olivedrab"
                : "transparent",
            }}
          >
            <TbAlertSquareRounded size="22" />{" "}
            <span className="nav-text">Alerts</span>
          </Link>
          {/* <Link id="t-1" to={'/my-profile'} className="menu-item" style={{ backgroundColor: isActive('/my-profile') ? 'olivedrab' : 'transparent' }}> <FaRegUser size="20" /> <span className='nav-text'>My Profile</span> */}

          {/* </Link> */}
        </div>
      </div>
    </>
  );
};
export default VerticalMenu;
